export default {
  baseUrl: 'http://localhost:5000/connected-devices/api/v1/admin/dev/',
}
